import type { InboxViewColumnType } from "@/types/inboxView/inboxView";
import { CopyableEmail } from "@/components/common/CopyableEmail";

export function formatCell(value: unknown, type: InboxViewColumnType): JSX.Element | string {
  if (value === null || value === undefined || value === "") return <span className="text-[#B6C0CC]">—</span>;
  switch (type) {
    case "boolean":
      return value === true ? (
        <span className="text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#E4F5EC] text-[#1FAA59]">yes</span>
      ) : (
        <span className="text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#FFE9E9] text-[#E5484D]">no</span>
      );
    case "date": {
      const d = new Date(String(value));
      if (isNaN(d.getTime())) return String(value);
      return d.toLocaleDateString();
    }
    case "number":
      return String(value);
    case "enum":
      return <span className="text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-genie-primary/10 text-genie-primary">{String(value)}</span>;
    case "text":
    default:
      return <CopyableEmail email={String(value)} />;
  }
}
